import { render, staticRenderFns } from "./NufusCuzdaniCard.vue?vue&type=template&id=d61d4dcc&scoped=true"
import script from "./NufusCuzdaniCard.vue?vue&type=script&lang=ts"
export * from "./NufusCuzdaniCard.vue?vue&type=script&lang=ts"
import style0 from "./NufusCuzdaniCard.vue?vue&type=style&index=0&id=d61d4dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d4dcc",
  null
  
)

export default component.exports